/* eslint-disable i18next/no-literal-string */

import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Loader2 } from 'lucide-react';

import { useDmaAssessment } from '@/features/esg/dma/api/use-dma-assessments';
import { DmaAssessmentLayout } from '@/features/esg/dma/components/DmaAssessmentLayout';

export const Route = createFileRoute('/_authenticated/esg/double-materiality/$assessmentId')({
  component: DmaAssessmentRoute,
});

function DmaAssessmentRoute() {
  const { assessmentId } = Route.useParams();
  const { data, isLoading } = useDmaAssessment(assessmentId);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!data) {
    return (
      <div className="py-12 text-center text-muted-foreground">
        DMA assessment not found.
      </div>
    );
  }

  return (
    <DmaAssessmentLayout assessment={data}>
      <Outlet />
    </DmaAssessmentLayout>
  );
}
